import React from 'react'
import { Container } from './styled'

type Props = {
  value: string
}

export const ActionCardNotification = ({ value }: Props) => {
  return (
    <Container>
      <span>{value}</span>
    </Container>
  )
}
